import React from 'react';
import styles from '../../index.module.sass';

const PolicesAndProceduresING = () => {
  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <div className={styles.Titles}>
          <div className={styles.title}>Policies </div>
          <div className={styles.subtitle}>and Procedures.</div>
        </div>
        <p className={styles.paragraphTitle}>Code of Ethics</p>
        <p>
          As an independent Consultant of Terramar Brands LLC (hereinafter “TERRAMAR” or “the
          Company”) I hereby promise and agree that:
        </p>
        <ol>
          <li className={styles.list}>
            I will be honest and forthright &nbsp;
            <span className={styles.span}>
              in all my transactions while acting as an Independent Consultant of TERRAMAR and will
              perform all activities in a manner that will enhance my reputation and the reputation
              of TERRAMAR.
            </span>
          </li>
          <li className={styles.list}>I will not engage in any illegal or deceptive practices.</li>
          <li className={styles.list}>
            I will respect the time and privacy &nbsp;
            <span className={styles.span}>
              of everyone I contact as potential retail customers or Independent Consultants of
              TERRAMAR. I will be courteous and respectful towards everyone I interact with in the
              course of my TERRAMAR business. I recognize TERRAMAR’s managers have strong personal
              convictions regarding the ethical conduct of all TERRAMAR Independent Consultants.
            </span>
          </li>
          <li className={styles.list}>
            I will fulfill my leadership responsibilities as a Sponsor, &nbsp;
            <span className={styles.span}>
              including training and providing support to the Independent Consultants within my
              organization. I will provide ongoing support to my organization, acknowledging that
              the people I sponsor will have a greater opportunity for success in TERRAMAR when they
              receive ongoing training and support.
            </span>
          </li>
          <li className={styles.list}>
            I will not make any income claims or representations &nbsp;
            <span className={styles.span}>
              regarding the TERRAMAR Compensation Plan, except those contained in official TERRAMAR
              literature. I acknowledge that a Terramar Independent Consultant’s success depends on
              multiple factors, such as amount of time and effort committed to their business, as
              well as their organizational ability
            </span>
          </li>
          <li className={styles.list}>
            I will not make any claims regarding TERRAMAR´s products, services or income opportunity
            &nbsp;
            <span className={styles.span}>
              except as published in official TERRAMAR literature. I will remember that even my
              personal experience of benefits received from TERRAMAR products, services or income
              opportunity may be interpreted as TERRAMAR claims if I use those experiences as a
              sales tool.
            </span>
          </li>
          <li className={styles.list}>
            I will always honor TERRAMAR’s 100 percent satisfaction, money-back guarantee
            <span className={styles.span}>when dealing with my retail customers.</span>
          </li>
          <li className={styles.list}>
            I understand and agree that I am solely responsible for all financial and legal
            obligations
            <span className={styles.span}>
              incurred by me in the course of my business as an Independent Consultant of TERRAMAR
              products and services, including self-employment taxes, income taxes, sales taxes,
              license fees, etc. I understand that I am an independent contractor for all federal
              and state tax purposes.
            </span>
          </li>
          <li className={styles.list}>
            I will compete aggressively but fairly &nbsp;
            <span className={styles.span}>
              <b></b> , and I will respect the participants of other network marketing
              opportunities. I will not solicit from the Independent Consultant lists or customer
              lists of other network marketing companies, nor will I focus my sales or recruiting
              efforts solely on the customers or Independent Consultants of any one other company. I
              will not use sales materials that are regarded as proprietary by other companies.
            </span>
            <p className={styles.paragraphTitle}>
              Independent Consultant Statement of Policies and Procedures &nbsp;
            </p>
            <ol>
              <li className={styles.list}>Becoming an Independent Consultant.</li>
              <p className={styles.span}>
                An applicant becomes an Independent Consultant of TERRAMAR when the online
                application is completed and accepted by TERRAMAR.
              </p>
              <p className={styles.span}>
                Once the application is accepted, the Independent Consultant is entitled to buy
                TERRAMAR products at the Consultant price, develop their lineage and qualify under
                the compensation plan to receive commissions.
              </p>
              <p className={styles.span}>
                TERRAMAR reserves the right to reject any Independent Consultant Application or
                renewal application, including, but not limited to, the application of any person
                who has had a financial interest of any kind in any TERRAMAR Independent
                Consultantship under a different sponsor in the preceding six months.
              </p>

              <li className={styles.list}>Legal age</li>
              <p className={styles.span}>
                Independent Consultants must be of legal age in the state or province of their
                residence.
              </p>

              <li className={styles.list}>Independent Consultant rights</li>
              <p className={styles.span}>
                All Independent Consultants are authorized to sell TERRAMAR products and services,
                and to participate in the TERRAMAR compensation plan. All Independent Consultants
                may enroll new Independent Consultants.
              </p>

              <li className={styles.list}>No purchase required.</li>
              <p className={styles.span}>
                No person is required to purchase any TERRAMAR products or services.
              </p>

              <li className={styles.list}>Married couples</li>
              <p className={styles.span}>
                Married couples who both wish to participate must share a single Independent
                Consultantship. Independent Consultants who marry must maintain separate Independent
                Consultant status, unless one is the direct sponsor of the other, or they have the
                same sponsor, in which case their Independent Consultantships may be consolidated.
                When a couple sharing an independent Consultantship divorces or separates, TERRAMAR
                will continue to pay commissions and bonuses as before the divorce or separation
                until it receives written notice, signed by both parties or by a court decree
                specifying how future commissions and bonuses should be paid
              </p>

              <li className={styles.list}>Simultaneous interests.</li>
              <p className={styles.span}>
                Independent Consultants and their spouses or dependents may not have a financial
                interest in more than one Independent Consultantship without the written consent
                from TERRAMAR. For example, neither a shareholder of a corporation that is a
                Terramar Independent Consultant, nor a partner of a partnership that is a Terramar
                Independent Consultant may become a Terramar Independent Consultant individually.
              </p>

              <li className={styles.list}>Requirements for corporations, partnership and trust</li>
              <p className={styles.span}>
                Corporations, Partnerships and Trusts may apply to become Independent Consultants of
                TERRAMAR only when the Independent Consultant Application and Agreement is
                accompanied by copies of the following documents:
              </p>

              <ol type='A'>
                <p className={styles.span}>
                  Articles of incorporation, partnership agreement or trust documents as filed with
                  the State
                </p>

                <p className={styles.span}>
                  Corporate applicants must disclose a complete list of all directors, officers, and
                  shareholders involved in the corporation. Partnerships must disclose all general
                  and limited partners. Trusts must disclose the trustee and beneficiary.
                </p>

                <p className={styles.span}>
                  Proof must be provided of a Federal ID Number and a copy of the Annual
                  Certification from the Secretary of State corresponding to the registration of the
                  trust, partnership or corporation must be provided.
                </p>

                <p className={styles.span}>
                  Shareholders, partners, beneficiaries and trustees, directors and officers, as
                  applicable, agree to remain personally liable to TERRAMAR and bound by its rules
                  and regulations.
                </p>
              </ol>

              <li className={styles.list}>Fictitious and assumed names prohibited</li>
              <p className={styles.span}>
                A person or entity may not apply as an Independent Consultant using a fictitious or
                assumed name.
              </p>

              <li className={styles.list}>Independent Contractor status.</li>
              <p className={styles.span}>
                All Independent Consultants are independent contractors of TERRAMAR, and not
                franchisees, joint ventures, partners, employees, or agents of TERRAMAR. Independent
                Consultants are strictly prohibited from stating or implying, whether verbally or in
                writing that they are franchisees, joint ventures, partners, employees, or agents of
                TERRAMAR. Independent Consultants may not bind TERRAMAR to any obligation or
                commitment
              </p>

              <li className={styles.list}>Annual renewal.</li>
              <p className={styles.span}>
                Independent Consultants must annually renew their Consultantship on the anniversary
                of their enrollment with TERRAMAR. Although the responsibility for renewing belongs
                with each Independent Consultant, TERRAMAR will provide a reminder when their
                renewal is due. Any Independent Consultant wishing not to renew shall be deemed to
                have voluntarily terminated their Independent Consultantship, and thereby forfeit
                the Independent Consultantship, all sponsorship rights, position earned, and any
                future compensation.
              </p>

              <li className={styles.list}>Indemnity</li>
              <p className={styles.span}>
                Independent Consultants agree to indemnify and hold harmless TERRAMAR, its
                shareholders, employees, agents, and successors in interest from and against any
                claim, demand, liability, loss, cost, or expense, including, but not limited to,
                attorney’s fees arising or alleged to arise in connection with the Independent
                Consultantship, and any matter related to the compliance with the Independent
                Consultant Agreement.
              </p>

              <li className={styles.list}>Taxes</li>
              <p className={styles.span}>
                Independent Consultants will be considered as independent contractors for all
                federal or state tax purposes. As such, they will not be considered as employees,
                franchisees, joint ventures, partners, employees, or agents with respect to the
                Internal Revenue Code, Social Security Act, Federal Unemployment Act, state
                unemployment laws, or any other applicable federal, state, or local law or
                regulation
              </p>

              <li className={styles.list}>Legal compliance</li>
              <p className={styles.span}>
                All Independent Consultants shall comply with all applicable federal, state and
                local laws and regulations in the operation of their businesses. Each Independent
                Consultant is responsible for their own managerial decisions and expenditures,
                including all estimated income and self-employment taxes. At the end of each
                calendar year, TERRAMAR will issue an IRS Form 1099-MISC for non-employee
                compensation for Independent Consultants as required by law
              </p>

              <li className={styles.list}>Independent Consultant identification number</li>
              <p className={styles.span}>
                All Independent Consultants will be required to provide a Social Security number or
                Federal ID number, which TERRAMAR will use this number until an Independent
                Consultant identification number is assigned and for all government reporting
                purposes. While respecting the rights of the “un-numbered,” TERRAMAR chooses, as a
                right of contract, to only enter into agreements with those who are willing to
                provide a taxpayer identification number. The Independent Consultant identification
                number must be indicated on all correspondence with TERRAMAR, including paperwork
                for enrolling, product ordering, etc.
              </p>

              <li className={styles.list}>Other products and services</li>
              <p className={styles.span}>
                Independent Consultants are not restricted from selling the products and services of
                other companies. However, promotion of products, services or income opportunities of
                other direct selling companies, to TERRAMAR customers or Independent Consultants, is
                strictly prohibited. Any Independent Consultant found in violation of this rule
                risks suspension or termination of their Independent Consultantship.
              </p>

              <li className={styles.list}>No exclusive territories.</li>
              <p className={styles.span}>
                There are no exclusive territories for marketing or enrollment purposes, nor shall
                any Independent Consultant imply or state that they have an exclusive territory.
                There are no geographical limitations (within the U.S. and its territories) on the
                enrollment of Independent Consultant
              </p>

              <li className={styles.list}>Enrolling not compensated</li>
              <p className={styles.span}>
                TERRAMAR Independent Consultants may enroll other Independent Consultants in the
                TERRAMAR program. However, Independent Consultants are compensated solely based on
                business volume, and never for enrolling additional new participants into the
                program.
              </p>

              <li className={styles.list}>Multiple applications</li>
              <p className={styles.span}>
                If one applicant submits multiple Applications, only the first completed form to be
                received by TERRAMAR will be accepted. TERRAMAR reserves the right to resolve such
                disputes.
              </p>

              <li className={styles.list}>Obligations of Enrollers.</li>
              <p className={styles.span}>
                Independent Consultants who choose to enroll are required to assure the adequate
                training of their enrolled Independent Consultants. “Adequate training” includes
                (but is not limited to) education regarding TERRAMAR rules and regulations,
                compensation plan, product information, sound business practices, sales strategies,
                and ethical conduct. An enroller must maintain an ongoing, professional leadership
                association with Independent Consultants in their organization and must fulfill the
                obligation of performing as a bona fide sales mentor or sales coach in the sale or
                delivery of products to the end consumer. Examples of such supervision may include,
                but are not limited to: newsletters, written correspondence, in- person meetings,
                telephone contact, voice mail, electronic mail, training sessions, accompanying
                individuals to TERRAMAR training, and sharing genealogy information with those
                enrolled. Independent Consultants should be able to provide evidence to TERRAMAR
                upon request of ongoing compliance of their sponsorship responsibilities.
              </p>

              <li className={styles.list}>Transferring sponsorship.</li>
              <p className={styles.span}>
                Because of the critically important relationship between a sponsor upline and a
                downline consultant, TERRAMAR strongly discourages requests or attempts to transfer
                sponsorship. However, in an extraordinary situation, a transfer request, without
                group, will be considered but only with the notarized signatures of consent from the
                five immediate uplines. A transfer request, with group, will be considered with the
                notarized signatures of consent from the five immediate uplines, and the notarized
                signatures of consent of each downline wishing to be included in the transfer. All
                sponsorship transfers require the final approval from TERRAMAR, whose decision will
                take into account the overall good of the Company. An administrative fee may be
                charged for modifying the corporate records.
              </p>

              <li className={styles.list}>Voluntary termination.</li>
              <p className={styles.span}>
                An independent Consultant may voluntarily terminate their Independent Consultantship
                by failing to renew when applicable or by providing written notice to TERRAMAR.
                Voluntary termination is effective upon receipt of such notice by TERRAMAR at its
                main office. An Independent Consultant who has voluntarily terminated their
                Consultantship may reapply for enrollment after a period of six months from the date
                of termination.
              </p>

              <li className={styles.list}>Involuntary termination.</li>
              <p className={styles.span}>
                An Independent Consultant may be terminated for violating any of the terms of this
                Agreement. TERRAMAR will provide written notice of termination of the Independent
                Consultantship to the Independent Consultant who has committed the violation, citing
                evidence of the violation. Should no response be provided by the Independent
                Consultant within the following 15 days, termination shall be deemed effective upon
                TERRAMAR´s final decision. Notice of the decision will be sent by certified mail to
                the violating Independent Consultant’s address on record. In instances where
                applicable state law is inconsistent with the foregoing, the procedure shall be
                automatically adjusted to comply with such law. An involuntarily terminated
                Independent Consultant may not reapply to TERRAMAR for a period of one year
                following the effective date of termination.
              </p>

              <li className={styles.list}>Appeals</li>
              <p className={styles.span}>
                An involuntarily terminated Independent Consultant may appeal the termination by
                submitting a written appeal letter, stating the grounds for the appeal. This letter
                must be sent via U. S. Mail or private delivery service RETURN RECEIPT REQUESTED and
                must be received by TERRAMAR within 15 days from the date the Company´s termination
                notice was sent. If the Company has not received a letter of appeal by that
                deadline, the involuntary termination shall automatically become final. If an
                Independent Consultant files a timely appeal, TERRAMAR will, at its sole discretion,
                review and reconsider the termination and notify the Independent Consultant of its
                decision. The Company´s decision shall be final and subject to no further review. If
                the appeal is denied, the termination shall remain in effect as of the date of the
                Company’s original termination notice.
              </p>

              <li className={styles.list}>Effect of suspension</li>
              <p className={styles.span}>
                Should TERRAMAR deem it necessary to suspend an Independent Consultant, such
                suspension may result in the Independent Consultant losing the right to represent
                themselves as a TERRAMAR Independent Consultant, and that any commissions, royalty
                overrides, or bonuses due will be held by TERRAMAR pending resolution. At the
                Company’s discretion, products and services may be purchased by a suspended
                Independent Consultant at wholesale prices. However, if suspension results in
                termination, product and services may be purchased only from another TERRAMAR
                Independent Consultant.
              </p>

              <li className={styles.list}>Effect of termination.</li>
              <p className={styles.span}>
                In the event an Independent Consultant is terminated, effective with such
                termination the Independent Consultant can no longer sell TERRAMAR products and
                services, nor enroll other Independent Consultants. The Independent Consultant also
                loses all rights to commissions, bonuses, and all other benefits.
              </p>

              <li className={styles.list}>Limits on transferability or sale. </li>
              <p className={styles.span}>
                An independent Consultant may sell, assign, or transfer their Independent
                Consultantship to a non-TERRAMAR Independent Consultant, but first they must grant
                their immediate sponsor a right of first refusal. No sale, assignment, or transfer
                shall be effective without the prior written approval of TERRAMAR whose approval
                will not be unreasonably withheld. If the Company determines, in its sole
                discretion, that the transfer was made to evade compliance with this Agreement, such
                transfer shall be declared null and void, and the Consultantship shall revert back
                to the transferring Independent Consultant, who shall be treated as if the transfer
                had never occurred. An administrative fee may be charged for changing the corporate
                records.
              </p>

              <li className={styles.list}>Vendor relationships.</li>
              <p className={styles.span}>
                No Independent Consultant shall contact, directly or indirectly, or speak to or
                communicate with any representative of any supplier or manufacturer of TERRAMAR,
                except as arranged by TERRAMAR. Violation of this rule may result in termination of
                Independent Consultant benefits and possible claims for damages if the supplier
                relationship is compromised by the Independent Consultant contact.
              </p>

              <li className={styles.list}>Confidentiality Agreement. </li>
              <p className={styles.span}>
                Information contained in any genealogy or downline report provided to an Independent
                Consultant by TERRAMAR is proprietary and confidential to TERRAMAR and is
                transmitted to the Independent Consultant in strictest confidence. The Independent
                Consultant agrees not to disclose such information to any third party directly or
                indirectly, nor use the information to compete with TERRAMAR or for any purpose
                other than promoting the TERRAMAR income opportunity. The Independent Consultant and
                TERRAMAR agree that, without this confidentiality and non-disclosure agreement,
                TERRAMAR would not provide the information to the Independent Consultant. Any
                Independent Consultant who is found to be in violation of this rule risks suspension
                or termination. TERRAMAR reserves the right to seek damages to the fullest extent of
                the law.
              </p>

              <li className={styles.list}>Succession</li>
              <p className={styles.span}>
                Upon the death of an Independent Consultant, the Independent Consultantship shall
                pass by will or intestate succession, as provided by law. TERRAMAR will require the
                successor to sign and be bound by the then current Independent Consultant Agreement.
                The successor shall have the same rights and obligations as any other TERRAMAR
                Independent Consultant.
              </p>

              <li className={styles.list}>Trademarks</li>
              <p className={styles.span}>
                The name TERRAMAR and the names of all TERRAMAR products and services are the
                registered or unregistered trademarks of and owned by TERRAMAR. Only TERRAMAR is
                authorized to produce and market products and literature under these trademarks. Use
                of the TERRAMAR name on any item not produced or authorized by TERRAMAR is
                prohibited.
              </p>

              <li className={styles.list}>Imprinted checks.</li>
              <p className={styles.span}>
                TERRAMAR Independent Consultants are not permitted to use the TERRAMAR trade name or
                any of its trademarks on their business or personal checking/bank accounts. However,
                Independent Consultants may print the phrase “Independent Consultant of TERRAMAR
                products” on their business checks.
              </p>

              <li className={styles.list}>Yellow and white page listing</li>
              <p className={styles.span}>
                Independent Consultants are not permitted to use the TERRAMAR trade name when
                listing their telephone and fax numbers in the white or yellow page sections of the
                telephone book.
              </p>

              <li className={styles.list}>Imprinted business cards or letterheads</li>
              <p className={styles.span}>
                TERRAMAR Independent Consultants are not permitted to incorporate into their own
                business card or letterhead graphics any TERRAMAR trade name or trademarks. Only the
                approved TERRAMAR graphics version and wording are permitted, and letterhead must be
                ordered either from TERRAMAR directly or from a Terramar approved source.
              </p>

              <li className={styles.list}>Company literature</li>
              <p className={styles.span}>
                Only official TERRAMAR literature may be used in presenting TERRAMAR products,
                services and the TERRAMAR income opportunity. Company literature may not be
                duplicated or reprinted without prior written permission from TERRAMAR. All
                promotional material of any nature, including electronic, must be approved in
                advance and in writing by TERRAMAR.
              </p>

              <li className={styles.list}>Media interviews.</li>
              <p className={styles.span}>
                Independent Consultants are prohibited from granting radio, television, newspaper,
                or magazine interviews, or using public appearances, public speaking engagements, or
                making any type of statement to the public media to publicize TERRAMAR, its
                products, services or their individual TERRAMAR business except with the express,
                written approval of TERRAMAR. All media contacts and inquiries must be coordinated
                through the approval and representation of a Terramar Corporate Representative.
              </p>

              <li className={styles.list}>Internet and web site policy.</li>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    No Independent Consultant may independently design a web site that uses the
                    names, logos, or product descriptions of TERRAMAR without the prior written
                    authorization from TERRAMAR.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    No Independent Consultant may use “blind” ads on the Internet making product or
                    income opportunity representations that are or can be associated with TERRAMAR.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    No Independent Consultant may under any circumstance use the Internet for the
                    purpose of indiscriminate “mass” or unsolicited mailing, generally known as
                    “spamming.”
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    No Independent Consultant may violate any local, state, or federal laws
                    regarding the Internet use or any generally accepted ethical codes of Internet
                    conduct.
                  </span>
                </li>
              </ol>

              <li className={styles.list}>Independent communications.</li>
              <p className={styles.span}>
                Independent Consultants, as independent contractors, are encouraged to distribute
                information and direction to their respective downlines. TERRAMAR encourages the use
                of newsletters, training workshops, and other organizational programs. Independent
                Consultants must identify their personal communications as such, and not give the
                impression that such communications are the official communications of TERRAMAR.
              </p>

              <li className={styles.list}>Independent Consultant training.</li>
              <p className={styles.span}>
                Independent Consultants are responsible for providing training to the Independent
                Consultants they enroll. Training assistance is provided in their Backoffice and
                audiovisual materials. Also, each Independent Consultant receives periodic TERRAMAR
                publications that includes ongoing training and product and services information.
                Further, Independent Consultants may attend local and regional training workshop and
                participate in TERRAMAR-originated national training conference calls.
              </p>

              <li className={styles.list}>Endorsements</li>
              <p className={styles.span}>
                No endorsements of any kind, including by TERRAMAR officers, may be alleged, except
                as expressly communicated in TERRAMAR literature or approved in writing.
              </p>

              <li className={styles.list}>Copying prohibited. </li>
              <p className={styles.span}>
                Independent Consultants shall not copy for sale or personal use audio, or videotaped
                material detailing the TERRAMAR income opportunity or product or service
                presentations, events, or speeches, including conference calls without written
                permission from TERRAMAR. TERRAMAR may seek injunctive relief or damages from the
                violator for the unauthorized use of TERRAMAR copyrights, trademarks, and materials.
                Video or audio taping of TERRAMAR meetings and conferences is strictly prohibited.
                Still photography is allowable at the discretion of the meeting host.
              </p>

              <li className={styles.list}>Telephone answering</li>
              <p className={styles.span}>
                Independent Consultants may not answer the telephone by saying “TERRAMAR,” or in any
                other manner that would lead the caller to believe that they have reached TERRAMAR’s
                corporate offices.
              </p>

              <li className={styles.list}>Repackaging prohibited.</li>
              <p className={styles.span}>
                Independent Consultants may not repackage any TERRAMAR products, services, or
                materials in any way.
              </p>

              <li className={styles.list}>Independent Consultant Application and Agreement.</li>
              <p className={styles.span}>
                Commissions and bonuses cannot be paid until a completed Independent Consultant
                Application and Agreement has been received and accepted by TERRAMAR. Commissions
                are paid ONLY on the sale of TERRAMAR products and services. No commissions are paid
                on the purchase of an Independent Consultant Start-Up kit, which is sold at Company
                cost.
              </p>

              <li className={styles.list}>Calendar period.</li>
              <p className={styles.span}>
                Commissions, bonuses, achievement awards and recognition are calculated on a monthly
                basis, according to the calendar month
              </p>

              <li className={styles.list}>Commission and override payment date.</li>
              <p className={styles.span}>
                Commissions are paid monthly, approximately within the first 10 days of the month
                for commissions earned during the preceding calendar month.
              </p>

              <li className={styles.list}>Commission payments.</li>
              <p className={styles.span}>
                Refer to the compensation plan described in the Consultant Manual.
              </p>

              <li className={styles.list}>Stockpiling prohibited.</li>
              <p className={styles.span}>
                The TERRAMAR program depends on retail sales to the end consumer; therefore, all
                forms of stockpiling or product loading are discouraged. TERRAMAR recognizes that
                Independent Consultants may wish to purchase certain products in reasonable
                quantities for their own use and for availability to new Independent Consultants at
                the time of their enrollment. However, TERRAMAR strictly prohibits the purchase of
                products in unreasonable quantities solely or the purpose of qualify for advancement
                in the compensation plan.
              </p>

              <li className={styles.list}>Sales volume qualification by order taking.</li>
              <p className={styles.span}>
                The Company has established minimum personal and group business volume requirements.
                Minimum business volume requirements may also be fulfilled by taking orders from
                retail customers which will be processed and shipped directly to the retail customer
                by the Company.
              </p>

              <li className={styles.list}>Shipping costs.</li>
              <p className={styles.span}>
                Independent Consultants have the responsibility to indicate destination address. The
                methods available are stated on each order form and the prepaid costs, if selected,
                can be calculated by the shipping and handling cost information also provided. NOTE:
                Should the receiving party of any order shipped from TERRAMAR refuse delivery and
                the shipment be returned to TERRAMAR, the ordering Independent Consultant’s
                Independent Consultant status will be change to “inactive” pending resolution of the
                delivery refusal. Non-accepted delivery charges will be debited to the Independent
                Consultant’s account.
              </p>

              <li className={styles.list}>Damaged Merchandise</li>
              <p className={styles.span}>
                The shipping Company is responsible for any damage that occurs after it takes
                physical custody of the goods. An independent Consultant who receives damaged goods
                should follow this procedure:
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>Accept delivery.</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Before the driver leaves, document on the delivery receipt the number of boxes
                    which seem to be damaged.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Save the damaged products or boxes for inspection by the shipping agent.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Make an appointment with the shipping Company to have the damaged goods
                    inspected.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>File a claim with the shipping Company.</span>
                </li>
              </ol>

              <li className={styles.list}>Receipts and suggested retail pricing.</li>
              <p className={styles.span}>
                Independent Consultants must provide all retail purchasers of TERRAMAR products with
                written receipts. This receipt form is available to all Consultants in their
                Backoffice. Although TERRAMAR provides a suggested retail price as a guideline,
                Independent Consultants may sell TERRAMAR products at whatever retail price they
                choose.
              </p>

              <li className={styles.list}>Minimum Advertised Price (MAP).</li>
              <p className={styles.span}>
                TERRAMAR establishes that the General Public Price (also referred to as the "Retail
                Price") published through its official channels shall be considered the Minimum
                Advertised Price (MAP) for all its products. The following shall be considered
                official price publication channels:
              </p>

              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>The Offers Catalog.</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>The Monthly Magazine</span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    The official website:
                    <a href='www.terramarbrandsusa.com'>www.terramarbrandsusa.com</a>
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    Terramar USA’s official social media accounts inspected.
                  </span>
                </li>
              </ol>

              <p className={styles.span}>
                This price must be honored across any authorized public channel of sale, promotion,
                or communication, including but not limited to personal social media accounts
                (Facebook, Instagram, TikTok, etc.), personal websites, independent printed
                catalogs, or any other direct or indirect sales medium accessible to the general
                public. It is strictly prohibited to advertise or publish prices below the MAP, or
                to use language suggesting unauthorized discounts such as: “special price,” “ask for
                price,” “exclusive offer,” “price by inbox,” “DM for more info,” etc.
              </p>

              <li className={styles.list}>Sales tax.</li>
              <p className={styles.span}>
                For purchases made from the Company, TERRAMAR collects and remits applicable state
                tax which may be due on the suggested selling price of those products and/or
                materials which are subject to tax. The applicable rate of tax due is based on the
                address to which the product and/or materials is shipped. Independent Consultants
                who request a tax-exempt purchase for resale from TERRAMAR (not permitted in all
                states) must provide the Company with a copy of their valid and current resale
                exemption certificate showing a resale tax number. This number must appear on all
                orders placed with TERRAMAR. The Independent Consultant must then collect the tax
                from their retail customer and remit it to the proper state and local taxing
                authority. All Independent Consultants must pay tax to the Company on their personal
                purchases made for personal use and consumption. As an Independent Consultant you
                agree to abide by the rules and procedures as set forth in the sales tax collection
                agreements that the Company may enter into with the various states and local
                jurisdictions.
              </p>

              <li className={styles.list}>Retail Establishments.</li>
              <p className={styles.span}>
                TERRAMAR products may not be sold to or in, or be displayed by any retail
                establishments, including, but not limited to, flea markets or trade shows, shopping
                mall booths or restaurants. As well as on marketplaces such as Amazon, eBay,
                Walmart, or any other online store. Exceptions require prior written approval.
              </p>

              <li className={styles.list}>Service oriented establishments.</li>
              <p className={styles.span}>
                It is permissible to take orders for TERRAMAR products and services in businesses
                such as professional services offices, “by appointment” establishments or similar
                non-retail establishments.
              </p>

              <li className={styles.list}>Price changes.</li>
              <p className={styles.span}>
                All TERRAMAR product and literature prices are subject to change without prior
                notice
              </p>

              <li className={styles.list}>Retail customer returns. </li>
              <p className={styles.span}>
                TERRAMAR offers a 100 percent unconditional money-back guarantee on products sold to
                all retail customers. Every TERRAMAR Independent Consultant must honor this
                guarantee. If a retail customer is dissatisfied with any TERRAMAR product for any
                reason, then that retail customer may return that product to the Independent
                Consultant from whom it was purchased, within 30 days, for either a replacement or a
                full refund of the purchase price. TERRAMAR will replace the returned product
                providing the following steps and conditions are met:
              </p>

              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    The product is returned to TERRAMAR by the Independent Consultant through whom
                    the purchase was made.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    The product must be received by TERRAMAR within ten days of the return date to
                    the Independent Consultant.
                  </span>
                </li>
                <li className={styles.list}>
                  <span className={styles.span}>
                    The return is accompanied by a completed and signed statement indicating:
                  </span>
                </li>
                <ol>
                  <li className={styles.list}>
                    <span className={styles.span}>
                      A signed statement from the retail customer explaining the reason for the
                      return.
                    </span>
                  </li>

                  <li className={styles.list}>
                    <span className={styles.span}>
                      A copy of the original retail sales receipt, and
                    </span>
                  </li>

                  <li className={styles.list}>
                    <span className={styles.span}>
                      The unused portion of the product in its original container.
                    </span>
                  </li>
                </ol>

                <li className={styles.list}>
                  <span className={styles.span}>
                    The name, address, and telephone number of the retail customer.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    Proper shipping box(es) and packing materials are to be used in packaging the
                    product(s) being returned for replacement, and the most economical shipping
                    method.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>
                TERRAMAR will cover the shipping cost of the replacement.
              </p>

              <p className={styles.span}>
                TERRAMAR will not reimburse the Independent Consultant for the purchase price of any
                retail customer returns or replace the products if the conditions of this policy are
                not met.
              </p>

              <li className={styles.list}>Quality control.</li>
              <p className={styles.span}>
                TERRAMAR will replace, within 30 days of purchase, any product found to be
                defective. However, no product should be returned to TERRAMAR without prior
                authorization. Please contact TERRAMAR at 01 800 313 0903 or by email to
                <span>
                  <a href='mailto:customerservices@tmbrandsusa.com' className={styles.link}>
                    &nbsp;customerservices@tmbrandsusa.com&nbsp;
                  </a>
                </span>
                and strictly comply with the following is requirements:
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    A written replacement request must be submitted, stating the reason for the
                    request, and accompanied by proof of payment and a copy of the purchase order
                    form or packing slip.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    TERRAMAR will instruct the Independent Consultant where to ship the product for
                    verification and will also provide the corresponding return labels. Upon receipt
                    and verification of the product, TERRAMAR will ship a replacement product as
                    appropriate.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>
                NOTE: Any return received without prior approval will cause the status of that
                Independent Consultant to be placed “inactive.” Furthermore, there is no guarantee
                that the product will be eligible for replacement
              </p>

              <li className={styles.list}>Termination returns.</li>
              <p className={styles.span}>
                Upon termination, if the Independent Consultant has purchased products for inventory
                purposes or sales aid material during the term of the contract, all unused and
                resalable products products in a resalable condition purchased within 12 months
                prior to cancellation, may be offered to TERRAMAR for repurchase. The repurchase
                shall be at a price of not less than 90 percent of the original net cost paid by the
                Consultant. In addition, the Company will honor statutory buyback requirements of
                every jurisdiction. TERRAMAR will also repurchase any sales materials and the
                TERRAMAR Start-Up kit for a period of one year from the time of purchase providing
                the materials are current and in resalable condition.
              </p>
              <ol type='a'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    A written return request must be submitted and accompanied by proof of payment
                    and a copy of the purchase order.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    TERRAMAR will instruct the Independent Consultant where to ship the products for
                    inventory and verification purposes, and will also provide the return shipping
                    labels. Once the products have been received and inspected, TERRAMAR will
                    process the applicable refund.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    Independent Consultant must pay the cost of return freight.
                  </span>
                </li>
              </ol>
              <p className={styles.span}>
                NOTE: Product or sales materials that are not in resalable condition will be
                returned to the Independent Consultant at their own expense.
              </p>

              <li className={styles.list}>Buyer’s right to cancel.</li>
              <p className={styles.span}>
                Federal law empowers a buyer the right to cancel certain sales without penalty prior
                to midnight of the third business day after the transaction. This rule applies to
                retail consumer sales of $25 or more that occur away from the seller’s main office.
                The TERRAMAR Sales Order form contains all legally required notices. It must be
                signed by the buyer, and two copies must be given to the buyer on every sale. In
                addition, the Independent Consultant must verbally inform the buyer of the three-day
                right to cancel at the time the contract is signed or the goods are purchase. With
                regard to products, when the Retail Customer Returns Policy (describe above)
                provides more favorable terms to the customer, that policy shall prevail. With
                regard to services, at the end of the three-day cancellation period has expired, all
                sales of services are considered final and non-returnable.
              </p>

              <li className={styles.list}>Independent Consultant’s responsibility.</li>
              <p className={styles.span}>
                If a retail customer mails or delivers to an Independent Consultant a valid notice
                of cancellation prior to midnight on the third business day after ordering or
                purchasing the program, service, and/or product, it must be honored by the
                Independent Consultant. If the buyer has already received the goods, they must be
                returned with the cancellation notice in substantially the same condition as
                originally delivered. With regard to services, the sealed materials describing and
                explaining the services must be returned unopened. Within ten business days after
                receiving the notice, the Independent Consultant must refund all payments made under
                the sales contract.
              </p>

              <li className={styles.list}>Liability.</li>
              <p className={styles.span}>
                To the extent permitted by law, TERRAMAR shall not be liable for and Independent
                Consultant releases TERRAMAR from any liability and waives all claims for any loss
                of profits, indirect, direct, special or consequential damages or any other loss
                incurred or suffered by Independent Consultant as a result of (a) the breach by
                Independent Consultant of this Agreement, (b) the operation of Independent
                Consultant’s business, (c) any incorrect or wrong data or information provided by
                Independent Consultant, or (d) the failure to provide any information or data
                necessary for TERRAMAR to operate its business, including without limitation, the
                enrollment process and acceptance of the Independent Consultant into the income
                opportunity or the payment of commissions and bonuses.
              </p>

              <li className={styles.list}>Record-keeping.</li>
              <p className={styles.span}>
                TERRAMAR recommends that all Independent Consultants keep complete and accurate
                records of all their business transactions. A recommended publication is IRS
                Publication 911 for Direct Sellers, available from any IRS Office, or on the
                official IRS website.
              </p>

              <li className={styles.list}>Income claims.</li>
              <p className={styles.span}>
                No income claims, income projections nor income representations may be made to
                prospective Independent Consultants. Any false, deceptive, or inaccurate statement
                regarding the opportunity or product/services are strictly prohibited. At times,
                Independent Consultants present hypothetical income figures based on the potential
                of network marketing as if they were actual income projections. This practice is
                counterproductive and prohibited, as it can lead to disappointment if real results
                do not align with those hypothetical expectations.
                <ol type='a'>
                  <li>Earnings Claims</li>
                  <ol>
                    <li>
                      Consultants are prohibited from making income statements, projections or
                      lifestyle claims (e.g., travel, car purchases, quitting jobs, etc.) that may
                      be misleading or lack substantiation.
                    </li>
                    <li>Only official materials approved by TERRAMAR may be used.</li>
                    <li>
                      All communications must clarify that income depends on individual effort, time
                      invested, skills, and other variable factors.
                    </li>
                  </ol>
                  <li>Products Claims</li>
                  <ol>
                    <li>
                      Consultants may not make medical, therapeutic, or curative claims regarding
                      TERRAMAR products.
                    </li>{' '}
                    <li>
                      Only benefits approved in official TERRAMAR literature may be communicated.
                    </li>
                    <li>
                      Personal experiences must not be used as a substitute for scientific evidence
                      or as a guarantee of results.
                    </li>
                  </ol>
                </ol>
              </p>

              <li className={styles.list}>Supervision and Monitoring</li>
              <p className={styles.span}>
                <ol type='a'>
                  <li>
                    TERRAMAR reserves the right to monitor social media and other forms of
                    communications.
                  </li>
                  <li>
                    Any material containing unapproved claims may be subject to immediate removal
                    upon request.
                  </li>
                </ol>
              </p>

              <li className={styles.list}>Compliance and Sanctions.</li>

              <p className={styles.span}>
                Failure to comply with this or any related policy—including but not limited to the
                Minimum Advertised Price (MAP) Policy and the Earnings & Product Claims Policy—will
                result in the following disciplinary actions:
                <ol type='a'>
                  <li>First violation: Formal written warning.</li>
                  <li>
                    Second violation: Temporary suspension of the Independent Consultant’s account
                    and business activities until compliance is restored.
                  </li>
                  <li>
                    Third violation: Immediate termination of the Independent Consultant’s contract.
                  </li>
                </ol>
              </p>
              <p className={styles.span}>
                TERRAMAR reserves the right to monitor, investigate, and enforce these policies
                through any legal or contractual means it deems necessary, and to escalate
                disciplinary actions depending on the severity or recurrence of the violation.
              </p>

              <li className={styles.list}>Amendments.</li>
              <p className={styles.span}>
                TERRAMAR reserves the right to amend this Agreement, its prices, products
                availability, and compensation plan as it deems appropriate. Amendments will be
                communicated to all Independent Consultants through TERRAMAR official publications.
                Amendments are effective and binding on all Independent Consultants as of the date
                of issuance.
              </p>

              <li className={styles.list}>Non-waiver provision.</li>
              <p className={styles.span}>
                The failure of TERRAMAR to exercise any power under this Agreement or to require
                strict compliance by an Independent Consultant with any obligation or provision
                contained herein, as well as any customary or differing practice of the parties at
                variance with this Agreement, shall not constitute a waiver of the Company’s right
                to demand exact compliance with this Agreement. Any waiver by the Company shall be
                valid only if made in writing and signed by an authorized officer of the Company.
                The Company’s waiver of a specific breach shall not affect or limit its rights with
                respect to any subsequent breaches, nor shall it affect the rights or obligations of
                other Independent Consultants. Likewise, any delay or omission by the Company to
                exercise any right arising from a breach shall not affect or limit the Company’s
                rights as to such breach or any future breaches.
              </p>

              <li className={styles.list}>Severability.</li>
              <p className={styles.span}>
                If, under any applicable law or binding regulation, any provision of this
                Agreement—including these rules and regulations, or any specification, standard, or
                operating procedure established by TERRAMAR—is deemed invalid or unenforceable,
                TERRAMAR shall have the right to modify such provision, specification, standard, or
                procedure to the extent necessary to make it valid and enforceable. The Independent
                Consultant shall be bound by any such modification, which shall be effective only
                within the jurisdiction where it is required.
              </p>

              <li className={styles.list}>Arbitration.</li>
              <ol type='A'>
                <li className={styles.list}>
                  <span className={styles.span}>
                    All disputes and claims related to TERRAMAR, its products, the Consultant
                    Agreement, or the TERRAMAR Compensation Plan, including but not limited to (1)
                    the rights and obligations of the Consultant and TERRAMAR, (2) any other claim
                    relating to the performance of either the Consultant or TERRAMAR under the
                    Consultant Agreement or the Rules and Regulations, and/or (3) the Consultant’s
                    purchase of TERRAMAR products shall be fully and finally settled by arbitration
                    in Miami, Florida or in another location designated by TERRAMAR, in accordance
                    with the Federal Arbitration Act and the Commercial Arbitration Rules of the
                    American Arbitration Association (AAA). Residents of Louisiana may arbitrate in
                    New Orleans. There shall be one arbitrator, an attorney at law, who must have
                    expertise in commercial law transactions, preferably with knowledge of the
                    direct selling industry, selected from the panel provided by the AAA. Each party
                    shall be responsible for its own costs and expenses of arbitration, including
                    legal and filing fees. If the Consultant files a claim or counterclaim against
                    TERRAMAR, it must be filed on an individual basis and not jointly with any other
                    Consultant, nor as part of any collective action. The decision of the arbitrator
                    shall be final and binding on both parties and may, if need be, be reduced to a
                    judgment in any court of competent jurisdiction. This arbitration agreement
                    shall survive any termination or expiration of the Consultant Agreement.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    Notwithstanding the foregoing, the arbitrator shall have no jurisdiction over
                    disputes relating to the ownership, validity or registration of any trademark or
                    other intellectual property or proprietary confidential information of TERRAMAR,
                    without the Company’s prior written consent. TERRAMAR may pursue appropriate
                    legal remedies in any applicable forum regarding such disputes or amounts owed.
                    In addition to monetary damages, TERRAMAR may seek injunctive relief against the
                    Consultant for any violation of the Agreement or misuse of TERRAMAR trademarks,
                    copyrights, or confidential information.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    Nothing in this clause shall prevent TERRAMAR from seeking and obtaining from
                    any competent court having jurisdiction a writ of attachment, a temporary
                    injunction, preliminary injunction and/or other judicial injunctive or emergent
                    relief available to safeguard and protect TERRAMAR interest prior, during or
                    after arbitration, or while awaiting the resolution thereof.
                  </span>
                </li>

                <li className={styles.list}>
                  <span className={styles.span}>
                    The existence of any claim or cause of action of the Consultant against
                    TERRAMAR, whether arising out of the Agreement or otherwise, shall not
                    constitute a defense to the Consultant’s obligations contained in the Consultant
                    Agreement or the Rules.
                  </span>
                </li>
              </ol>

              <li className={styles.list}>Jurisdiction.</li>
              <p className={styles.span}>
                All disputes and claims related to TERRAMAR, this Agreement, the TERRAMAR
                compensation plan, or its products, the rights and obligations of an Independent
                Consultant and TERRAMAR, its products, or the rights and obligations of an
                Independent Consultant shall be finally and exclusively resolved in Miami, Florida,
                or in another location designated by TERRAMAR. Residents of Louisiana: In the event
                of a jurisdictional dispute, the Independent Consultant may file their claim or
                lawsuit within the State of Louisiana, and the governing laws of that state shall
                apply.
              </p>

              <li className={styles.list}>Limitation of damages.</li>
              <p className={styles.span}>
                To the extent permitted by law, TERRAMAR and its affiliates, officers, directors,
                employees, and other representatives shall not be liable—and the Independent
                Consultant expressly waives any claim—for loss of profits or for any incidental,
                special, consequential, or exemplary damages arising from any claim relating to
                acts, omissions, or breaches of TERRAMAR concerning the business relationship
                between the parties, whether based on contract, tort, or strict liability.
                Furthermore, it is agreed that any damages to the Independent Consultant shall not
                exceed, and is hereby expressly limited to, the value of unsold TERRAMAR products
                and services in the Consultant’s possession, together with any commissions pending
                payment.
              </p>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PolicesAndProceduresING;
